import { SnailyError } from './SnailyError'

export class LinkedInError extends SnailyError {
	constructor(message: string, metadata?: unknown) {
		super(message, metadata)
		this.name = 'LinkedInError'

		if (typeof Error.captureStackTrace === 'function') {
			Error.captureStackTrace(this, LinkedInError)
		}
	}
}
